import { Grid, Stack, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "store/authReducer";
import { storeMenu } from "store/menuReducer";
import { handleRoleSelection, setCreds, setRoles } from "store/roleReducer";

const GsisPACallback = () => {
    if (import.meta.env.MODE === "development") {
        globalThis.serverData = {
            status: "error",
            data: {
                token:
                    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIxMzA2NzM2ODciLCJuYmYiOjE3NTg2MTQ2OTAsImV4cCI6MTc1ODYxNDk5MCwiaWF0IjoxNzU4NjE0NjkwfQ.PnybKFXQ0tFM3VO4PzP8PSjCiAhEnY1gTIR09GK6A2I",
            },
        };
    }

    const [data] = useState(globalThis.serverData || {});
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [show, setShow] = useState(false)


    useEffect(() => {
        try {
            if (data?.status === 'success') {
                if (data?.data?.status === 'select_urpfId') {
                    dispatch(setCreds({ creds: { isPaLogin: true, token: data?.data?.token } }));
                    dispatch(setRoles({ roles: data?.data?.data }));
                    dispatch(handleRoleSelection(true));
                    globalThis.serverData = null
                }
                else {

                    dispatch(
                        login({
                            token: data?.data?.token,
                            refreshToken: data?.data?.refreshToken,
                            user: data?.data?.user,
                            seasonId: data?.data?.season,
                        })
                    );

                    dispatch(storeMenu(data?.data?.menu));
                    globalThis.serverData = null
                    navigate("/home");
                }
            }
            else {
                enqueueSnackbar(data?.message || 'Ανεπιτυχής προσπάθεια σύνδεσης.', {
                    variant: "error",
                })
                globalThis.serverData = null
                setShow(true)
            }
        }
        catch (e) {

            console.log(e);
            enqueueSnackbar("Ανεπιτυχής προσπάθεια σύνδεσης.", {
                variant: "error",
            });
            setShow(true)
        }


    }, [data]);


    return (
        <Grid
            justifyContent="center"
            alignItems="center"
            container
            sx={{ height: "100%", minHeight: '55vh' }}
        >
            <Grid item xs={6} sm={4}>

                {show && <Stack justifyContent="center" spacing={2} alignItems="center">


                    <Typography
                        paragraph
                        onClick={() => navigate("/")}
                        sx={{
                            cursor: "pointer",
                            "&:hover": {
                                textDecoration: "underline",
                            },
                            fontSize: "1rem",
                            fontWeight: 800,
                            mb: 0,
                        }}
                    >
                        Επιστροφή στην αρχική σελίδα
                    </Typography>
                </Stack>}
            </Grid>
        </Grid>
    );
};

export default GsisPACallback;
